import * as React from 'react';
import { useContext, useReducer, useState, useEffect } from "react";

import { MessagesContext } from "../common/context";
import { messagesReducer } from "../common/reducer";

import { TextField, initializeIcons } from "office-ui-fabric-react";
import { PrimaryButton, DefaultButton } from "office-ui-fabric-react/lib/Button";

import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { DetailsList, DetailsListLayoutMode, Selection, SelectionMode, IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { CommandBar, ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';

import { useErrorBoundary } from "use-error-boundary";
import log from 'loglevel';


import { emailServiceSend } from "../../model/emailService";

import { EditorConvertToHTML} from "./editorConvertToHTML";
import { Wys} from "./wys";
//import { TextEditor } from "./TextEditor.old";
import  * as uuidv4 from "uuid/v4";
import parse from "html-react-parser";
import { getFieldStyles, getStyle} from "./EditorContainer.Styles";


import { CONTENT_TYPE,  RENDER_FORMAT, PIVOT_KEY } from "../common/consts";

// const RENDER_FORMAT = {
//   Text : 0, // text as generated from items and edited from textbox
//   RichTextHtml : 1, //html edited by rich test editor
//   RawHtml : 2, // rawhtml as generated from templates and items
//   ParsedHtml : 3, // react components based on rawhtm
// }
/**
 * 
 * @param param0 
 * 
 * 
 */
export const EditorContainer = ({header, footer, context}) => {
    const { state , dispatch } = useContext(MessagesContext);
    const [recepients, setRecepients] = useState('gilstav@hotmail.com');
    const [subject, setSubject] = useState('Meeting Summary:');
    const [body, setBody] = useState('');
    const [headerText, setHeaderText] = useState(header);
    const [footerText, setFooterText] = useState(footer);

    
    //const [renderFormat, setRenderFormat] = useState(RENDER_FORMAT.Text);
    const [htmlChannelTemplate, setHtmlChannelTemplate] = useState('');
    const [htmlMessageTemplate, setHtmlMessageTemplate] = useState('');
    const [htmlReplyTemplate, setHtmlReplyTemplate] = useState('');
    const [rawHtmlBody, setRawHtmlBody] = useState('');
    const [parsedHtmlBody, setParsedHtmlBody] = useState();
    

    const { ErrorBoundary, didCatch, error, errorInfo } = useErrorBoundary();
    log.info(` @EditorContainer`);
    
  
    //Only generate edit from items if user marked to edit them
    useEffect(() => {  
      log.info(` useEffect @ EditorContainer`);

      if (state.loadSelectedItems) {
          //Generate edit content from selected items
          appendItems();
        }      
    }, [state.loadSelectedItems]);


    
const  handleRenderMode = (_renderFormat)=>{
      log.info(` handleRenderMode @ EditorContainer`);
      const _payloadRenderFormat = { 
        renderFormat: _renderFormat,
      }
      dispatch({ type: "SET_RENDER_FORMAT", payload: _payloadRenderFormat })   
}  


    const _items= [
      {
        key: 'share',
        text: 'Submit',
        iconProps: { iconName: 'Share' },
        onClick: () => {handleUpdateShare()}

      }

    ];
    
    //const stateItemsLength = state.messages.length;
    const stateItemsLength = state.selectedItems.length;
    const title = stateItemsLength > 0 ? `${stateItemsLength} Messages`
    : "No Items Selected!";

    //const itmText = `create a new component`;
    const getName = (user) =>  user ? user : 'Unknown';
    const messageDate = (date) => date ?  new Date(date).toString() : 'Undated';
    //const getStyle = (type) => "text-align:left";
    const getItemUrl =(webUrl)=> webUrl ? webUrl : 'Empty';
    const getItemHtmlText =(text)=> text ? text : 'Empty';

    const getItemHtml = ({ id, text, webUrl, user, date, type }) => {
      if (getItemUrl(webUrl) !== "Empty") {
        return `<div style="${getStyle(type)}" >
                  <span style="${getStyle(type)}"><br/><strong>${getName(user)}</strong> | <a
                      href="${getItemUrl(webUrl)}"
                      target="_blank"
                      rel="noopener noreferrer"
                  >  Open post in Teams </a> | Date: ${messageDate(date)}: 
                  </span><br/>${getItemHtmlText(text).trim()}
                </div>`;
      } else {
        return `<div style="${getStyle(type)}" >
        <span style="${getStyle(type)}"><br/><strong>${getName(user)}</strong> | Date: ${messageDate(date)}: 
        </span><br/>${getItemHtmlText(text).trim()}
      </div>`;
      }
    };




    const getOpeningHtml = () => `
    <div  >      
      <p style="${getStyle(0)}">
       Date: ${new Date().toString()} 
       <strong>Meeting Notes: </strong>: 
        <br/>
      </p>
    </div>
    `;
    
    const appendItems = () => {
      log.info(` appendItems @ EditorContainer`);
      
        let __selectedItems=[];  
        __selectedItems= [...state.selectedItems];  

        const _headerText = (state.emailHeader !== null) && (state.emailHeader !== undefined) ? state.emailHeader.trim() : ''; 
        const _footerText = (state.emailFooter !== null) && (state.emailFooter !== undefined) ? state.emailFooter.trim() : ''; 

        let appendedItems = _headerText;
        let appendedHtmlItems = _headerText !== '' ? `<div>${_headerText}</div><br/>` : ``
        
        __selectedItems.forEach((_item) => {
            appendedItems = appendedItems  + formatItem(_item);
            appendedHtmlItems = appendedHtmlItems  + formatHtmlItem(_item);
          }
        );
        
        appendedHtmlItems = _headerText !== '' ? appendedHtmlItems + `<br/><div>${_footerText}</div>`
        : appendedHtmlItems;

        appendedItems = appendedHtmlItems + `<div>${_footerText}</div>`;

        const _payloadText = { 
          textBody: appendedItems,
        }
        dispatch({ type: "SET_TEXT_BODY", payload: _payloadText })
                
        const _payloadHTML = { 
          htmlBody: appendedHtmlItems,
        }
        dispatch({ type: "SET_HTML_BODY", payload: _payloadHTML })
        
      };


      const handleReset = ()=>{
        log.info(` handleReset @ EditorContainer`);
        const _payloadText = { 
          textBody: '',
        }
        dispatch({ type: "SET_TEXT_BODY", payload: _payloadText })
                
        const _payloadHTML = { 
          htmlBody: '',
        }
        dispatch({ type: "SET_HTML_BODY", payload: _payloadHTML })

        const _paylod = {
          loadSelectedItems: true
        };
        dispatch({ type: "SET_EDIT_SELECTED_ITEMS", payload: _paylod });

        const _payload = { 
          editorState: null
      }
      dispatch({ type: "SET_EDITOR_STATE", payload: _payload })

      }

      const formatItem = ({id,text,webUrl,user}) => {
        log.info(` formatItem @ EditorContainer`);
        const _itemUser = user ? `\nParticipant: ${user }` : ''
        const _itemText = text ? `\n${text} \n` : ''  
        return(`${_itemUser} ${_itemText}` )
      }

      const formatHtmlItem = (_item) => {
        log.info(` formatHtmlItem @ EditorContainer`);
        return(getItemHtml(_item))
      }

      
      const renderTextBody = () => {
        log.info(` renderTextBody @ EditorContainer`);        
        return (
          <div/> 
          
        );
      };
       // <TextEditor   />
      const renderRawHtmlBody = () => {
        log.info(` renderRawHtmlBody @ EditorContainer`);        
        return (
          <div >
            {getOpeningHtml()}
          <TextField
            label = 'HtmlBody:'
            value={rawHtmlBody}
            multiline
            borderless
            autoAdjustHeight
            rows={1}
            styles={getFieldStyles}
            onChange={(event, newValue) => {
              setRawHtmlBody(newValue);
            }}
          />
          </div>
        );
      };
    
 
      const renderParsedHtmlBody = () => {
        log.info(` renderParsedHtmlBody @ EditorContainer`);        
        return (
          <>
            {parsedHtmlBody} 
         </>
        );
      };
      
      const renderRichTextHtmlBody = () => {
        log.info(` renderRichTextHtmlBody @ EditorContainer`);
        return (
          <ErrorBoundary
            render={() => <Wys />}
            renderError={({ error, errorInfo }) => (
              <MyErrorComponent error={error} />
            )}
          ></ErrorBoundary>
        );
      };

    const handleUpdateShare = () =>{      
      log.info(` renderRichTextHtmlBody @ EditorContainer`);                      
      const _payload =  
        { 
          bodyContent: state.htmlBody,
          bodyContentType: CONTENT_TYPE.HTML
        }

      dispatch({ type: "SET_BODY_CONTENT", payload: _payload })
      
      const __payload = { pivotKey:  PIVOT_KEY.SHARE};
      dispatch({ type: "SET_PIVOT_KEY", payload: __payload })
      
      const payload2 = {
        loadSelectedItems: false 
      };
      dispatch({ type: "SET_EDIT_SELECTED_ITEMS", payload: payload2 });

    }
 
    const MyErrorComponent = ({error})=>{
      log.error(` MyErrorComponent @ EditorContainer - error ${error.message}`);                      
      return (
      <div >error</div>
      )
    }

  const renderCommandBar = () => {
    log.info(` renderCommandBar @ EditorContainer`);
    return (
      <ErrorBoundary
        render={() => <CommandBar items={_items} />}
        renderError={({ error, errorInfo }) => (
          <MyErrorComponent error={error} />
        )}
      ></ErrorBoundary>
    );
  };

  return (
    <> 
        {renderCommandBar()}
        {renderRichTextHtmlBody()}
    </>
  )    
};

           {/* {renderMode()} */}
            {/* {renderRecepients()} */}
            {/* {renderSubject()} */}
            {/* { 
                state.renderFormat == RENDER_FORMAT.Text ? renderTextBody() :
                state.renderFormat == RENDER_FORMAT.RawHtml ? renderRawHtmlBody() : 
                state.renderFormat == RENDER_FORMAT.RichTextHtml? renderRichTextHtmlBody() :
                renderParsedHtmlBody() 
            } */}
            {/* <PrimaryButton 
                onClick={(event) => {handleSend(event,context);}} 
                style={{ marginRight: "8px" }}> 
              Send 
            </PrimaryButton> */}

      // ,
      // ,
      //  {
      //    key: 'header',
      //    text: 'Header',
      //    iconProps: { iconName: 'Share' },
      //    onClick: ()=>{handleAddHeader()}
      //  },
      //  {
      //   key: 'footer',
      //   text: 'Footer',
      //   iconProps: { iconName: 'Share' },
      //   onClick: ()=>{handleAddFooter()}
      // }



      // ,
      //  {
      //    key: 'reset',
      //    text: 'Reset',
      //    iconProps: { iconName: 'Share' },
      //    onClick: ()=>{handleReset()}
      //  }
      // {
      //   key: 'richTextMode',
      //   text: 'Rich Text',
      //   iconProps: { iconName: 'Share' },
      //   onClick: ()=>handleRenderMode(RENDER_FORMAT.RichTextHtml)
      // }


                // //Reset the toggle value to be set again next time the user wants to push itsems to edito
          //   const _paylod = {
          //     loadSelectedItems: false 
          //   };
          //   dispatch({ type: "SET_EDIT_SELECTED_ITEMS", payload: _paylod });


                    // //Reset the toggle value to be set again next time the user wants to push itsems to edito
          //   const _paylod = {
          //     loadSelectedItems: false 
          //   };
          //   dispatch({ type: "SET_EDIT_SELECTED_ITEMS", payload: _paylod });

                  // if (stateItemsLength > 0)
        // {
        //   selectedItems = state.ges.filter(
        //         (itm) => (  itm.selected )
        //   );
        // } 
        // {
        //   selectedItems = state.messages.filter(
        //         (itm) => (  itm.selected )
        //   );
        // } 

      // const renderRecepients = () => {
      //   return (
      //     <div >
      //     <TextField
      //       label = 'Email Recepients:'
      //       value={recepients}
      //       multiline
      //       borderless
      //       autoAdjustHeight
      //       rows={1}
      //       styles={getFieldStyles}
      //       onChange={(event, newValue) => {
      //           setRecepients(newValue);
      //       }}
      //     />
      //     </div>
      //   );
      // };
    
      // const renderSubject = () => {
      //   return (
      //     <div >
      //     <TextField
      //       label = 'Subject:'
      //       value={subject}
      //       multiline
      //       borderless
      //       autoAdjustHeight
      //       rows={1}
      //       styles={getFieldStyles}
      //       onChange={(event, newValue) => {
      //           setSubject(newValue);
      //       }}
      //     />
      //     </div>
      //   );
      // };
    
      // const options: IChoiceGroupOption[] = [
      //   { key: 'Text', text: 'Text Editor', iconProps: { iconName: 'CalendarDay' } },
      //   { key: 'RichTextHtml', text: 'Rich Editor', iconProps: { iconName: 'Calendar' }}
      //  // { key: 'RawHtml', text: 'Html', iconProps: { iconName: 'CalendarWeek' }},
      //   // { key: 'ParsedHtml', text: 'HTML Preview', iconProps: { iconName: 'Calendar' }},
      // ];


      /**
       * Set the render mode in the UI and save this is context based on UI choice
       */
      // const renderMode = () => {

      //  // alert(`state.renderFormat: ${state.renderFormat}`)
      //     return <ChoiceGroup 
      //         label="Show as:" 
      //         defaultSelectedKey={options[state.renderFormat].key}
      //         options={options} 
      //         onChange = {(event,option) => {          
      //           const _payloadRenderFormat = { 
      //             renderFormat: RENDER_FORMAT[option.key],
      //           }
      //           dispatch({ type: "SET_RENDER_FORMAT", payload: _payloadRenderFormat })
      //         }} 
      //       />;
      // };

